import { useEffect, useState } from "react";
import { apiGet } from "@/lib/api";

// Polls a builder render job until it's done or failed
export const useRenderJob = (onDone, onFail) => {
  const [job, setJob] = useState(null);
  useEffect(() => {
    if (!job) return undefined;
    const t = setInterval(() => apiGet(`/builder/jobs/${job}`).then((j) => {
      if (j.status === "done") { setJob(null); onDone(j.url, j); }
      if (j.status === "failed") { setJob(null); onFail(j.error); }
    }).catch(() => {}), 3000);
    return () => clearInterval(t);
  }, [job]); // eslint-disable-line react-hooks/exhaustive-deps
  return [job, setJob];
};

export const money = (n) => `$${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

export const FINISH_LABEL = { gloss: "Gloss", satin: "Satin", matte: "Matte", metallic: "Metallic", colorshift: "Color shift", iridescent: "Iridescent", chrome: "Chrome" };

// Same math as the server: labor + material tier + add-ons
export const priceOf = (cfg, color, addons) => {
  if (!cfg || !color) return { items: [], total: 0 };
  const items = [{ name: "Full wrap labor", price: cfg.labor }, { name: `Wrap material — ${color.name}`, price: cfg.materials[cfg.tiers[color.finish]] }];
  addons.forEach((a) => { const ad = cfg.addons.find((x) => x.id === a.id); if (ad) items.push({ name: `${ad.name}${a.color ? ` — ${a.color}` : ""}`, price: ad.price }); });
  return { items, total: items.reduce((s, i) => s + i.price, 0) };
};

export const swatch = (c) => (c.hex2 ? `linear-gradient(135deg, ${c.hex}, ${c.hex2})` : c.finish === "chrome" ? `linear-gradient(135deg, #fff, ${c.hex} 45%, #222 70%, ${c.hex})` : c.hex);
